import { render, staticRenderFns } from "./FormSubHeaders.vue?vue&type=template&id=273980ce&"
import script from "./FormSubHeaders.vue?vue&type=script&lang=js&"
export * from "./FormSubHeaders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports